import * as SEARCH_ACTION from 'constant/action/search'
import { handleActions } from 'redux-actions'

const initialState = {
  defaultSelectedKeys: null,
  pagination: {},
  searchResults: {},
  treeObject: null
}

export default handleActions(
  {
    [SEARCH_ACTION.UPDATE_SEARCH]: (state, action) => ({
      ...state,
      searchResults: action.payload
    }),
    [SEARCH_ACTION.UPDATE_SEARCH_PAGINATION]: (state, action) => ({
      ...state,
      pagination: action.payload
    }),
    [SEARCH_ACTION.UPDATE_SEARCH_TERM]: (state, action) => ({
      ...state,
      searchTerm: action.payload
    }),
    [SEARCH_ACTION.UPDATE_TREE_OBJECT]: (state, action) => ({
      ...state,
      treeObject: action.payload
    }),
    [SEARCH_ACTION.UPDATE_SELECTED_KEYS]: (state, action) => ({
      ...state,
      defaultSelectedKeys: action.payload
    })
  },
  initialState
)
